import {c_yellow} from '../a-Graphic/Colors';
import {c_light, c_background} from '../a-Graphic/Colors';
import {c_gradient_greens as gradient_greens, c_gradient_reds as gradient_reds} from '../a-Graphic/Colors';
import {wz_size} from '../a-Graphic/Layout';

import {getRange, rangeToThresholds} from './thresholds_functions';

import * as d3 from "d3";
import * as ss from "simple-statistics";

const L = window.L;

// ----------------------------------   MY MAP   --------------------------------------

function getMyMap(id, scale = false, padding = 0.3, background = true, zoom=true, attribution=true){
  var mymap = L.map(id, {
    center: [49, 0],
    zoom: 8,
    zoomDelta: 0.75,
    zoomSnap: padding,
    attributionControl: attribution,
    zoomControl: zoom,
    scrollWheelZoom: false,
    fadeAnimation: false
  });

  if (background){
    var mapbox_grey = 'https://api.mapbox.com/styles/v1/maelb96/ckvgdgsew4o8514nzwt93grne/tiles/{z}/{x}/{y}?access_token={accessToken}';
    var mapbox_beige = 'https://api.mapbox.com/styles/v1/maelb96/ckuz6hglv0hwk14rs0kaxav3r/tiles/{z}/{x}/{y}?access_token={accessToken}';
    L.tileLayer(mapbox_beige, {
    attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
    maxZoom: 18,
    id: 'mapbox/streets-v11',
    tileSize: 512,
    zoomOffset: -1,
    accessToken: 'pk.eyJ1IjoibWFlbGI5NiIsImEiOiJjaWx6ZjhmOWEwMGhxdm1tNThxamljbmtiIn0.cTyK6__rQH7lhZntrQlhWg'
    }).addTo(mymap);
  }

  /*
  L.tileLayer('https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png', {
    maxZoom: 20,
    attribution: '&copy; OpenStreetMap France | &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(mymap);
  }*/

  // ---SCALE
  if (scale===true){
    L.control.scale().addTo(mymap);
  }
  return mymap
}


// --------------------------------   UTILITIES  ----------------------------------------

function calcDist(coord1, coord2){
  let v = [coord1[0] - coord2[0], coord1[1] - coord2[1]]
  let conv_deg_km = [Math.PI / 180 * 6400, Math.PI / 180 * 4400]
  let v_conv = [v[0]*conv_deg_km[0], v[1]*conv_deg_km[1]]
  let crow_fly_dist = Math.sqrt(v_conv[0]**2 + v_conv[1]**2)
  // To estimate dist via road
  // From crow-fly distances to real distances, or the origin of detours, Heran"
  let dist = crow_fly_dist * (1.1 + 0.3 * Math.exp(-crow_fly_dist / 20))
  return dist
}

// --------------------------------   LEGEND  ----------------------------------------

function getLegend(values){
  let colors = gradient_greens
  let split_nb = colors.length

  let [range, range_labels] = getRange("bloue", values, split_nb)

  const v_max = Math.max(...values);
  const v_min = Math.min(...values);
  const c_nb = colors.length;

  var legend = {};
  colors.map((c, i) => legend[i] = [])
  values.map((v) => legend[numToAnalog(v, v_min, v_max, c_nb)].push(v))

  var legend_colors = Object.keys(legend).filter((key) => legend[key].length>0).map((key) => colors[key])
  var legend_intervals = Object.keys(legend).filter((key) => legend[key].length>0).map((key) => [Math.min(...legend[key]), Math.max(...legend[key])])

  return [colors, range_labels]
}

function getLegendMode(mode, values, colors){
  let split_nb = colors.length
  let [range, range_labels] = getRange(mode, values, split_nb)
  return [range_labels, colors]
}

function numToAnalog(v, v_min, v_max, nb){
  let step = (v_max - v_min) / nb
  if (v == v_max){
    return nb - 1
  }
  return Math.trunc((v - v_min) / step)
}


function numToAnalogPercentile(v, values, nb){
  let sorted_values = [...values].sort((a, b) => a - b)
  let step = Math.floor(values.length / nb)
  let value = Math.min(Math.floor(sorted_values.indexOf(v) / step), nb-1)

  return value
}

function getLegendFlows(values){
  let colors2 = gradient_reds
  const v_max = Math.max(...values);
  const v_min = Math.min(...values);

  const step = (v_max-v_min)/colors2.length
  var intervals = [];
  for  (let i = 0; i < colors2.length; i++) {
    intervals.push([Math.trunc(v_min + step*i), Math.trunc(v_min + step*(i+1))])
  }
  return [colors2, intervals]
}


// --------------------------------   POPUP  ----------------------------------------
function managePopup(element, content, map){
  /*
  let popup = L.popup({
        autoPan: false
    })
      .setLatLng(element.latlng)
      .setContent(content);
  element.bindPopup(popup);
  element.on('mouseover', function (e) {
      this.openPopup();
  });
  element.on('mouseout', function (e) {
      this.closePopup();
  });
  */

  var popup = L.popup({autoPan: false});
  popup.setContent(content);
  element.bindPopup(popup);

  element.on('mouseover', function (e) {
    var popup = e.target.getPopup();
    popup.setLatLng(e.latlng).openOn(map);
  });

  element.on('mouseout', function(e) {
     e.target.closePopup();
  });

  element.on('mousemove', function (e) {
    e.target.closePopup();
    var popup = e.target.getPopup();
    popup.setLatLng(e.latlng).openOn(map);
  });
}


// --------------------------------   NAMES  ----------------------------------------

function createCommunesNamesLayerEasy(map, communes){
  communes = communes.slice().sort((c1, c2)=> c2.population - c1.population).slice(0, 10)
  let coords = communes.map((c)=>c.center)
  let names = communes.map((c)=>c.name)
  var nameMarkers = [];
  for (var i=0; i<coords.length; i++){
      let nameIcon = L.divIcon({
        className: 'my-div-icon',
        html: '<p class="map name">' + names[i] + "</p>"
      });
      let nameMarker = L.marker(coords[i], {icon: nameIcon});
      nameMarkers.push(nameMarker);
  }
  let names_layer = L.featureGroup(nameMarkers);
  names_layer.addTo(map);
  return names_layer
}

function createNamesLayer(map, coords, names){
  var nameMarkers = [];
  for (var i=0; i<coords.length; i++){
      let nameIcon = L.divIcon({
        className: 'my-div-icon',
        html: '<p class="map name">' + names[i] + "</p>"
      });
      let nameMarker = L.marker(coords[i], {icon: nameIcon});
      nameMarkers.push(nameMarker);
  }
  let names_layer = L.featureGroup(nameMarkers);
  names_layer.addTo(map);
  return names_layer
}

// --------------------------------   COMMUNES  ----------------------------------------

function createCommunesLayer(map, communes, labels=null, color=c_light){
  let communes_g = [];
  for (var i=0; i<communes.length; i++){
    var c = communes[i]
    for (let o of c.outline){
      let commune = L.polygon(o, {
        color: "#fff",
        fillColor: color,
        weight: 1.5,
        opacity: 0.8,
        fillOpacity: 0.8,
      });
      if(labels!=null){
        managePopup(commune, "<p class='leaflet_map_popup'>" + labels[i] + "</p>", map);
      }
      communes_g.push(commune);
    }
  }
  let communes_layer = L.featureGroup(communes_g);
  communes_layer.addTo(map);
  return communes_layer
}

function createCommuneBordersLayer(map, communes){
  let communes_g = [];
  for (let c of communes){
    for (let o of c.outline){
      let commune = L.polygon(o, {
        color: "#fff",
        fillColor: c_light,
        weight: 1.5,
        opacity: 1,
        fillOpacity: 0.4,
      });
      communes_g.push(commune);
    }
  }
  let communes_layer = L.featureGroup(communes_g);
  communes_layer.addTo(map);
  return communes_layer
}

function createCommuneMassLayer(map, communes, masses, labels=null, scale_mode="ckmeans", colors=gradient_greens){
  let [range, range_labels] = getRange(scale_mode, masses, colors.length)
  let thresholds = rangeToThresholds(range)
  let scale = d3.scaleThreshold()
                .domain(thresholds)
                .range(colors);

  let communes_g = [];
  for (var i=0; i<communes.length; i++){
    var color_commune = scale(masses[i])
    for (let o of communes[i].outline){
      let commune = L.polygon(o, {
        color: "#fff",
        fillColor: color_commune,
        weight: 1.5,
        opacity: 0.85,
        fillOpacity: 0.8,
      });
      if(labels!=null){
        managePopup(commune, "<p class='leaflet_map_popup'>" + labels[i] + "</p>", map);
      }
      communes_g.push(commune);
    }
  }
  let communes_layer = L.featureGroup(communes_g);
  communes_layer.addTo(map);
  return communes_layer
}

function createCommuneLayerFlows(map, communes, labels, func){
  let communes_g = [];
  for (var i=0; i<communes.length; i++){
    for (let o of communes[i].outline){
      let commune = L.polygon(o, {
        color: "#fff",
        fillColor: c_light,
        weight: 1.5,
        opacity: 1,
        fillOpacity: 0.4,
      });
      if(labels!=null){
        managePopup(commune, "<p class='leaflet_map_popup'>" + labels[i] + "</p>", map);
      }
      commune.on('mouseover', function (e) {
          func(communes[i].geo_code);
      });
      commune.on('mouseout', function (e) {
      });
      communes_g.push(commune);
    }
  }
  let communes_layer = L.featureGroup(communes_g);
  communes_layer.addTo(map);
  return communes_layer
}


// --------------------------------   EPCI  ----------------------------------------

function createEPCILayer(map, epci_geojson, labels=null, color=c_yellow){
  let epci_g = [];
  for (var i=0; i<epci_geojson.length; i++){
    var e = epci_geojson[i]
      let epci = L.geoJSON(e, {
        color: "#fff",
        fillColor: color,
        weight: 1.5,
        opacity: 0.8,
        fillOpacity: 0.75,
      });
      if(labels!=null){
        managePopup(epci, "<p class='leaflet_map_popup'>" + labels[i] + "</p>", map);
      }
      epci_g.push(epci);
  }
  let communes_layer = L.featureGroup(epci_g);
  communes_layer.addTo(map);
  return communes_layer
}

// --------------------------------   RESIDENTIAL AREAS  ----------------------------------------

function createResidentialAreasMassLayer(map, residential_areas, masses=null, labels=null, colors=gradient_greens){
  function getColor(m) {
    const m_max = Math.max(...masses);
    const m_min = Math.min(...masses);
    let p = 100 / (m_max - m_min) * (m - m_min);
    let colors_nb = colors.length - 1
    return colors[Number(Math.round(p / (100 / colors_nb)))];
  }
  let r_areas = [];
  for (var i=0; i<residential_areas.length; i++){
    let ra = residential_areas[i]
    let color_ra;
    if (masses != null){
      color_ra = getColor(masses[i])
    } else {
      color_ra = c_light
    }
    let r_area = L.polygon(ra.outline, {
        color: color_ra,
        fillOpacity: 1,
        weight: 2,
        opacity: 1
      });

    if(labels != null){
      managePopup(r_area, "<p class='leaflet_map_popup'>" + labels[i] + "</p>", map);
    }
    r_areas.push(r_area);
  }
  let r_areas_layer = L.featureGroup(r_areas);
  r_areas_layer.addTo(map);
  return r_areas_layer//, hab_limit1, hab_limit2
}

function createResidentialAreasWhiteZoneLayer(map, residential_areas, wz_coords, distances, limit1=1.5, limit2=5, colors=gradient_reds){
  let wz_areas = [];
  let hab_limit1 = 0;
  let hab_limit2 = 0;

  for (var i=0; i<residential_areas.length; i++){
    let ra = residential_areas[i]
    let min_dist_areas = Math.min(...wz_coords.map((wz) => calcDist(ra.coords, wz)))
    let color_wz = min_dist_areas > limit2 ? colors[3] : (min_dist_areas > limit1 ? colors[1] : "transparent")

    let wz_area = L.circleMarker(ra.coords, {
      radius: wz_size,
      color: color_wz,
      fillColor: color_wz,
      fillOpacity: 0.15,
      weight: 0,
      opacity: 1
    });
    wz_areas.push(wz_area);
  }
  let wz_areas_layer = L.featureGroup(wz_areas);
  wz_areas_layer.addTo(map);
  return wz_areas_layer//, hab_limit1, hab_limit2
}



  // --------------------------------   AREAS / PLACES  ----------------------------------------

  function createAreasLayer(map, areas, commutes, info, color=null){
      var masses = Object.values(commutes).map((c) => Object.values(c).reduce((a, b) => a + b, 0));
      var max_mass = correctValues(Math.max(...masses));
      var min_mass = correctValues(Math.min(...masses));

      function correctValues(v){
        return Math.log(v+500)
        //return v
      }

      function getRadius(mass){
        mass = correctValues(mass);
        const r_min = 5;
        const r_max = 40;
        var radius = (r_max-r_min)/(max_mass-min_mass)*(mass-min_mass) + r_min;
        if (max_mass-min_mass == 0){
          return (r_min + r_max)/2;
        }
        return radius
      }

      var areas_g = []
      for (let a of areas){
        let mass = Object.values(commutes[a.id]).reduce((a, b) => a + b, 0);
        let area = L.circleMarker(a.coords,
          {
          radius: getRadius(mass),
          color: "#fff",
          fillColor: color == null ? c_yellow : color,
          weight: 2, //1,
          opacity: 1, //0.9,
          fillOpacity: 1, //0.75,
        });
        if (info !== null && commutes !== null){
          area.on('mouseover', function (e) {
            var total_flow = Object.values(commutes[a.id]).reduce((a, b) => a + b, 0);
            var total_origin = ""
            var a_commutes = commutes[a.id]

            var a_commutes_list = Object.keys(a_commutes).map(function(key) {
              return [key, a_commutes[key]];
            });
            a_commutes_list = a_commutes_list.sort(function(first, second) {
              return second[1] - first[1];
            });
            a_commutes_list = a_commutes_list.slice(0,7)

            for (var a_c of a_commutes_list){
              var flow = a_c[1]
              var name = a_c[0]
              total_origin += "<p>- " + name + " (" + flow + " personnes) </p>"

            }
            info.innerHTML = "<p class='mb-1'>" + total_flow + " personnes vers " + a.name + ", principalement en provenance de :</p>" + total_origin;
          });
          area.on('mouseout', function (e) {
              info.innerHTML = "<p>Passer la souris sur les flux et lieux pour des informations spécifiques.</p>";
          });
        }

        areas_g.push(area);
      }
      var areas_layer = L.featureGroup(areas_g);
      areas_layer.addTo(map);
      return areas_layer
    }

function createPlacesLayer(map, coords, s = 20, c = c_yellow, labels=null){
    var places_g = []
    for (var i=0; i<coords.length; i++){
      let place = L.circleMarker(coords[i],
        {
        radius: s,
        color: "#fff",
        fillColor: c,
        weight: 1.3, //1,
        opacity: 1, //0.9,
        fillOpacity: 1, //0.75,
      });
      if(labels!=null){
        managePopup(place, "<p class='leaflet_map_popup'>" + labels[i] + "</p>", map);
      }
      places_g.push(place);
    }
    var places_layer = L.featureGroup(places_g);
    places_layer.addTo(map);
    return places_layer
}

function createAreasMassLayer(map, coords, masses, labels=null, color=null){
    var max_mass = correctValues(Math.max(...masses));
    var min_mass = correctValues(Math.min(...masses));

    let scale = d3.scalePow().exponent(1/3)
              .domain([d3.min(masses), d3.max(masses)])
              .range([5, 40])

    function correctValues(v){
      return Math.log(v+500)
      //return v
    }

    function getRadius(mass){
      mass = correctValues(mass);
      const r_min = 5;
      const r_max = 40;
      var radius = (r_max-r_min)/(max_mass-min_mass)*(mass-min_mass) + r_min;
      if (max_mass-min_mass == 0){
        return (r_min + r_max)/2;
      }
      return radius
    }

    var areas_g = []
    for (var i=0; i<coords.length; i++){
      let area = L.circleMarker(coords[i],
        {
        radius: scale(masses[i]),
        color: "#fff",
        fillColor: color == null ? c_yellow : color,
        weight: 1.5, //1,
        opacity: 1, //0.9,
        fillOpacity: 1, //0.75,
      });
      if (labels != null){
        managePopup(area, "<p class='leaflet_map_popup'>" + labels[i] + "</p>", map);
      }
      areas_g.push(area);
    }
    var areas_layer = L.featureGroup(areas_g);
    areas_layer.addTo(map);
    return areas_layer
  }

  function createGriddedLayer(map, coords, masses, labels=null,  scale_mode="ckmeans", colors=gradient_greens){
    let [range, range_labels] = getRange(scale_mode, masses, colors.length)
    let thresholds = rangeToThresholds(range)
    let scale = d3.scaleThreshold()
                  .domain(thresholds)
                  .range(colors);

      var areas_g = []
      for (var i=0; i<coords.length; i++){
        let area = L.circle(coords[i],
          {
          radius: 100,
          color: "#fff",
          fillColor: scale(masses[i]),
          weight: 0, //1,
          opacity: 1, //0.9,
          fillOpacity: 1, //0.75,
        });
        if (labels != null){
          managePopup(area, "<p class='leaflet_map_popup'>" + labels[i] + "</p>", map);
        }
        areas_g.push(area);
      }
      var areas_layer = L.featureGroup(areas_g);
      areas_layer.addTo(map);
      return areas_layer
    }

// --------------------------------   ROUTES  ----------------------------------------

    function createRoutesLayer(map, routes, labels=null, w=2, colors=gradient_reds){
      var routes_g = []
      for (var i=0; i<routes.length; i++){
          let route = L.polyline(routes[i], {
            color: "white",
            fillOpacity: 1,
            lineCap: "butt",
            weight: w+2,
            opacity: 1
          }).addTo(map);
          let route2 = L.polyline(routes[i], {
            color: colors[i%(colors.length)],
            fillOpacity: 1,
            weight: w,
            lineCap: "butt",
            opacity: 1
          }).addTo(map);
          if(labels!=null){
            managePopup(route2, "<p class='leaflet_map_popup'>" + labels[i] + "</p>", map);
          }
          routes_g.push(route);
          routes_g.push(route2);
        }
      var routes_layer = L.featureGroup(routes_g);
      routes_layer.addTo(map);
      return routes_layer
    }


    // --------------------------------   FLOWS  ----------------------------------------

    function createFlowsLayer(map, flows, info, colors=gradient_reds){
      const flow_values = flows.map((f) => f.id);
      const f_max = Math.max(...flow_values);
      const f_min = Math.min(...flow_values);

      function getColor(pop) {
        let p = 100 / (f_max - f_min) * (pop - f_min);
        let colors_nb = colors.length - 1
        return colors[Number(Math.round(p / (100 / colors_nb)))];
      }

      function getWidth(flow) {
        let w_min = 2;
        let w_max = 5;
        let f = (w_max - w_min) / (f_max - f_min) * (flow - f_min) + w_min;
        return f;
      }

      var flows_g = []
      for (let f of flows){
          let flow = L.polyline(f.iti2, {
            color: getColor(f.id),
            fillOpacity: 1,
            weight: getWidth(f.id),
            opacity: 1
          }).addTo(map);
          flow.on('mouseover', function (e) {
              info.innerHTML = "<p>Flux : " + f.id + " passagers journaliers</p>" ;
          });
          flow.on('mouseout', function (e) {
              info.innerHTML = "<p>Passer la souris sur les flux et lieux pour des informations spécifiques.</p>";
          });
          flows_g.push(flow);
        }
      var flows_layer = L.featureGroup(flows_g);
      flows_layer.addTo(map);
      return flows_layer
    }


    function createCommuneFlowsLayer(map, coords, masses, labels,scale_mode="ckmeans", colors=gradient_reds){
      let [range, range_labels] = getRange(scale_mode, masses, colors.length)
      let thresholds = rangeToThresholds(range)
      let scale_color = d3.scaleThreshold()
                    .domain(thresholds)
                    .range(colors);
      let scale_width = d3.scaleThreshold()
                    .domain(thresholds)
                    .range(ss.equalIntervalBreaks([2, 14], colors.length-1));
      let scale_radius = d3.scaleThreshold()
            .domain(thresholds)
            .range(ss.equalIntervalBreaks([15, 40], colors.length-1));


      var flows_g = []
      for (let i=0; i<coords.length; i++){
        let flow;
        if(coords[i][0] != coords[i][1]){
          flow = L.polyline(coords[i], {
            color: scale_color(masses[i]),
            fillOpacity: 1,
            weight: scale_width(masses[i]),
            opacity: 1
          }).addTo(map);}
        else{
          flow = L.circleMarker(coords[i][0], {
            radius: scale_radius(masses[i]),
            color: scale_color(masses[i]),
            fillOpacity: 0,
            weight: scale_width(masses[i]),
            opacity: 1
          }).addTo(map);
        }
          if(labels!=null){
            managePopup(flow, "<p class='leaflet_map_popup'>" + labels[i] + "</p>", map);
          }
          flows_g.push(flow);
        }
      var flows_layer = L.featureGroup(flows_g);
      flows_layer.addTo(map);
      return flows_layer
    }



export default getMyMap;

export {
  calcDist,
  managePopup,
  createResidentialAreasMassLayer, createResidentialAreasWhiteZoneLayer,
  createEPCILayer,
  createAreasLayer, createAreasMassLayer, createGriddedLayer,
  createCommunesLayer, createCommuneBordersLayer, createCommuneMassLayer,
  createCommuneLayerFlows,
  createRoutesLayer,
  createPlacesLayer,
  createNamesLayer, createCommunesNamesLayerEasy,
  createCommuneFlowsLayer,
  createFlowsLayer, getLegend, getLegendMode, getLegendFlows
};
